// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__37npu","form":"styles_form__2PBxH"};